import { TileProxy } from '../TileProxy.js';

export { LeafletTileProxy };

class LeafletTileProxy extends TileProxy {

    constructor(options) {
        super();

        const layer = L.tileLayer(options.url, {
            attribution: options.attribution,
            maxZoom: 18
        });

        layer.on("loading", (e) => this.fire("loading", e));
        layer.on("load", (e) => this.fire("load", e));

        this.leafletLayer = layer;
        this.leafletMap = null;
    }

    reload() {
        this.leafletLayer.redraw();
    }

    setZIndex(zIndex) {
        this.leafletLayer.setZIndex(zIndex);
    }

    setOpacity(opacity) {
        this.leafletLayer.setOpacity(opacity);
    }

    setProjection(crs) {
        const code = crs.replace(":", "");
        if (code in L.CRS) {
            this.leafletLayer.options.crs = L.CRS[code];
        }
    }

    addToMap(leafletMap) {
        this.leafletMap = leafletMap;
        this.leafletLayer.addTo(leafletMap);
    }

    removeFromMap() {
        this.leafletLayer.remove();
        this.leafletMap = null;
    }

}